import { useEffect } from "react";
import FooterTransparent from "../../Components/Footer";
import Headers from "../../Components/HeaderPublic";

function AvisoPage() {
  // Scroll hacia arriba al cargar la página
  useEffect(() => {
    window.scrollTo(0, 0);
    // El PageView se dispara de forma deduplicada desde usePageTracking (hook global).
  }, []); // Estilo CSS para forzar full width en header y footer
  const fullWidthStyle = {
    width: "100vw",
    position: "relative",
    left: "50%",
    right: "50%",
    marginLeft: "-50vw",
    marginRight: "-50vw",
    overflowX: "hidden",
  };

  // Contenido estático del aviso de privacidad
  const aviso = [
    {
      avisoPrivacidad: `
        <div class="space-y-4 sm:space-y-6">
          <div class="bg-blue-50 p-3 sm:p-4 md:p-6 rounded-lg border-l-4 border-blue-800">
            <p class="text-xs sm:text-sm text-gray-700 leading-relaxed">
              <strong>BAZAN OROZCO MARKETING CONSULTANTS SAS</strong> (en adelante, "Nosotros" o "el Responsable"), con domicilio en <strong>Calle de los Bejucos 37, Fraccionamiento Lomas de San Mateo, Naucalpan, Estado de México, CP 53227</strong>, con Registro Federal de Contribuyentes (RFC) <strong>BOMC221115369</strong>, te informa que somos el responsable del uso y protección de tus datos personales, en términos de la <strong>Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP)</strong> y su Reglamento.
            </p>
          </div>
          
          <div>
            <h2 class="text-lg sm:text-xl md:text-2xl font-bold text-blue-800 mb-2 sm:mb-3 md:mb-4 flex items-center">
              <i class='bx bx-info-circle text-2xl sm:text-3xl mr-2'></i>
              ¿Para qué fines utilizaremos tus datos personales?
            </h2>
            <p class="mb-2 sm:mb-3 md:mb-4 text-sm sm:text-base">Recopilamos tus datos para ofrecerte servicios relacionados con clústeres industriales y de negocios, como:</p>
            <ul class="list-disc pl-4 sm:pl-5 md:pl-6 space-y-1 sm:space-y-2 text-gray-700 text-xs sm:text-sm md:text-base">
              <li>Proporcionar información sobre eventos, directorios de empresas y recursos industriales.</li>
              <li>Gestionar suscripciones a newsletters, registros para webinars o descargas de guías.</li>
              <li>Enviar comunicaciones comerciales personalizadas (e.g., oportunidades de networking o promociones de socios).</li>
              <li>Realizar análisis de mercado y mejorar la experiencia en el sitio web.</li>
            </ul>
            <p class="mt-2 sm:mt-3 md:mt-4 text-gray-700 text-xs sm:text-sm md:text-base">
              Los datos que solicitamos incluyen: <strong>nombre, correo electrónico, teléfono, empresa, cargo</strong> y, en algunos casos, <strong>datos fiscales</strong> (solo con consentimiento expreso). <span class="font-semibold text-blue-800">No recabamos datos sensibles sin tu autorización explícita.</span>
            </p>
          </div>
          
          <div>
            <h2 class="text-lg sm:text-xl md:text-2xl font-bold text-blue-800 mb-2 sm:mb-3 md:mb-4 flex items-center">
              <i class='bx bx-shield-alt-2 text-2xl sm:text-3xl mr-2'></i>
              ¿Qué derechos tienes sobre tus datos personales (Derechos ARCO)?
            </h2>
            <p class="mb-2 sm:mb-3 md:mb-4 text-sm sm:text-base">Puedes ejercer los siguientes derechos en cualquier momento:</p>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 md:gap-4">
              <div class="bg-blue-50 p-2 sm:p-3 md:p-4 rounded-lg">
                <h3 class="font-bold text-blue-800 mb-1 sm:mb-2 text-sm sm:text-base">
                  <i class='bx bx-search-alt text-lg sm:text-xl mr-1'></i>
                  Acceso
                </h3>
                <p class="text-xs sm:text-sm">Conocer qué datos tenemos y cómo los usamos.</p>
              </div>
              <div class="bg-blue-50 p-2 sm:p-3 md:p-4 rounded-lg">
                <h3 class="font-bold text-blue-800 mb-1 sm:mb-2 text-sm sm:text-base">
                  <i class='bx bx-edit text-lg sm:text-xl mr-1'></i>
                  Rectificación
                </h3>
                <p class="text-xs sm:text-sm">Corregir datos inexactos o incompletos.</p>
              </div>
              <div class="bg-blue-50 p-2 sm:p-3 md:p-4 rounded-lg">
                <h3 class="font-bold text-blue-800 mb-1 sm:mb-2 text-sm sm:text-base">
                  <i class='bx bx-trash text-lg sm:text-xl mr-1'></i>
                  Cancelación
                </h3>
                <p class="text-xs sm:text-sm">Eliminarlos de nuestra base de datos (salvo obligaciones legales).</p>
              </div>
              <div class="bg-blue-50 p-2 sm:p-3 md:p-4 rounded-lg">
                <h3 class="font-bold text-blue-800 mb-1 sm:mb-2 text-sm sm:text-base">
                  <i class='bx bx-block text-lg sm:text-xl mr-1'></i>
                  Oposición
                </h3>
                <p class="text-xs sm:text-sm">Negarte al tratamiento para fines específicos (e.g., marketing).</p>
              </div>
            </div>
            <div class="mt-2 sm:mt-3 md:mt-4 p-2 sm:p-3 md:p-4 bg-yellow-50 border-l-4 border-yellow-500 rounded">
              <p class="text-xs sm:text-sm text-gray-700">
                <strong>Para ejercerlos:</strong> Envía una solicitud por escrito a 
                <a href="mailto:sbm@industrialbusinessclusters.com" class="text-blue-600 hover:underline font-semibold break-all"> sbm@industrialbusinessclusters.com</a> 
                o al domicilio indicado, incluyendo: nombre, domicilio, teléfono, descripción de la solicitud y documentos que acrediten tu identidad. 
                <strong>Responderemos en máximo 20 días hábiles.</strong>
              </p>
            </div>
          </div>
          
          <div>
            <h2 class="text-lg sm:text-xl md:text-2xl font-bold text-blue-800 mb-2 sm:mb-3 md:mb-4 flex items-center">
              <i class='bx bx-lock-alt text-2xl sm:text-3xl mr-2'></i>
              Opciones para limitar el uso o divulgación de tus datos
            </h2>
            <ul class="space-y-2 sm:space-y-3 text-gray-700 text-xs sm:text-sm md:text-base">
              <li class="flex items-start">
                <i class='bx bx-check-circle text-blue-600 text-lg sm:text-xl mr-2 mt-0.5 sm:mt-1 flex-shrink-0'></i>
                <span>Puedes limitar el uso de tus datos para marketing marcando la casilla correspondiente en formularios o solicitándolo vía correo electrónico.</span>
              </li>
              <li class="flex items-start">
                <i class='bx bx-check-circle text-blue-600 text-lg sm:text-xl mr-2 mt-0.5 sm:mt-1 flex-shrink-0'></i>
                <span><strong>No compartimos</strong> tus datos con terceros sin tu consentimiento, salvo con proveedores de servicios (e.g., plataformas de email como Mailchimp) bajo acuerdos de confidencialidad, o por mandato legal (e.g., autoridades fiscales).</span>
              </li>
              <li class="flex items-start">
                <i class='bx bx-check-circle text-blue-600 text-lg sm:text-xl mr-2 mt-0.5 sm:mt-1 flex-shrink-0'></i>
                <span>Si nos autorizas, podemos transferir datos a socios industriales para colaboraciones, pero siempre con tu aprobación.</span>
              </li>
            </ul>
          </div>
          
          <div>
            <h2 class="text-lg sm:text-xl md:text-2xl font-bold text-blue-800 mb-2 sm:mb-3 md:mb-4 flex items-center">
              <i class='bx bx-server text-2xl sm:text-3xl mr-2'></i>
              Medidas de seguridad
            </h2>
            <p class="text-gray-700 text-xs sm:text-sm md:text-base">
              Implementamos <strong>medidas técnicas, administrativas y físicas</strong> para proteger tus datos contra accesos no autorizados, pérdidas o alteraciones, conforme a estándares internacionales. Nuestros servidores están en <strong>nube segura en AWS</strong>.
            </p>
          </div>
          
          <div>
            <h2 class="text-lg sm:text-xl md:text-2xl font-bold text-blue-800 mb-2 sm:mb-3 md:mb-4 flex items-center">
              <i class='bx bx-refresh text-2xl sm:text-3xl mr-2'></i>
              Cambios al Aviso de Privacidad
            </h2>
            <p class="text-gray-700 text-xs sm:text-sm md:text-base">
              Este Aviso puede modificarse por cambios en nuestras prácticas o la ley. Te notificaremos vía email o en el sitio web con al menos <strong>30 días de anticipación</strong>. La versión actual es del <strong>06 de octubre de 2025</strong>.
            </p>
          </div>
          
          <div>
            <h2 class="text-lg sm:text-xl md:text-2xl font-bold text-blue-800 mb-2 sm:mb-3 md:mb-4 flex items-center">
              <i class='bx bx-envelope text-2xl sm:text-3xl mr-2'></i>
              Contacto
            </h2>
            <p class="mb-2 sm:mb-3 md:mb-4 text-gray-700 text-xs sm:text-sm md:text-base">
              Para más información, contáctanos:
            </p>
            
            <div class="bg-blue-800 text-white p-3 sm:p-4 md:p-6 rounded-lg">
              <h3 class="text-base sm:text-lg md:text-xl text-left font-bold mb-2 sm:mb-3 md:mb-4">Información de contacto</h3>
              <div class="space-y-1 sm:space-y-2 text-left text-xs sm:text-sm">
                <p class="flex items-start"><i class='bx bx-buildings text-lg sm:text-xl mr-2 flex-shrink-0'></i><strong>BAZAN OROZCO MARKETING CONSULTANTS SAS</strong></p>
                <p class="flex items-start"><i class='bx bx-map text-lg sm:text-xl mr-2 flex-shrink-0'></i><span>Calle de los Bejucos 37, Lomas de San Mateo, Naucalpan, Edo. Méx., CP 53227</span></p>
                <p class="flex items-start"><i class='bx bx-phone text-lg sm:text-xl mr-2 flex-shrink-0'></i><span>Teléfono: <a href="tel:5549769532" class="hover:underline">55 4976 9532</a></span></p>
                <p class="flex items-start"><i class='bx bx-envelope text-lg sm:text-xl mr-2 flex-shrink-0'></i><span>Correo: <a href="mailto:sbm@industrialbusinessclusters.com" class="hover:underline break-all">sbm@industrialbusinessclusters.com</a></span></p>
                <p class="flex items-start"><i class='bx bx-world text-lg sm:text-xl mr-2 flex-shrink-0'></i><span>Web: <a href="https://www.industrialbusinessclusters.com" target="_blank" rel="noopener noreferrer" class="hover:underline break-all">www.industrialbusinessclusters.com</a></span></p>
              </div>
            </div>
          </div>
          
          <div class="bg-green-50 p-3 sm:p-4 md:p-6 rounded-lg border-l-4 border-green-600 text-center">
            <p class="text-base sm:text-lg font-semibold text-green-800 mb-1 sm:mb-2">
              <i class='bx bx-check-shield text-2xl sm:text-3xl'></i>
            </p>
            <p class="text-gray-700 text-xs sm:text-sm md:text-base">
              <strong>¡Gracias por confiar en Industrial Business Clusters!</strong><br/>
              Tu privacidad es nuestra prioridad para fomentar un ecosistema industrial colaborativo y seguro.
            </p>
          </div>
          
          <div class="text-right italic text-gray-500 mt-3 sm:mt-4 md:mt-6 text-xs sm:text-sm">
            <p><i class='bx bx-calendar text-base sm:text-lg mr-1'></i>Última actualización: <strong>06 de octubre de 2025</strong></p>
          </div>
        </div>
      `,
    },
  ];

  return (
    <>
      {/* Header con ancho completo usando el estilo personalizado */}
      <div style={fullWidthStyle}>
        <Headers />
      </div>

      {/* Contenido principal centrado */}
      <div className="pb-8 sm:pb-12 md:pb-16 pt-20 sm:pt-24 px-4 sm:px-6 md:px-8 lg:px-12 min-h-screen bg-gray-50">
        <div className="max-w-full lg:max-w-7xl mx-auto">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-blue-800 mb-2 sm:mb-3">
            Aviso de Privacidad
          </h1>
          <p className="text-sm sm:text-base text-center text-gray-600 mb-4 sm:mb-6 md:mb-8 px-2">
            Conoce cómo protegemos y utilizamos tu información personal de
            acuerdo con la legislación mexicana.
          </p>

          <div className="bg-white border rounded-lg shadow-md overflow-hidden">
            <div className="flex justify-center w-full">
              {aviso.map((item, index) => (
                <div key={index} className="w-full p-4 sm:p-6 md:p-8 lg:p-10">
                  <div
                    className="text-gray-700 prose prose-sm sm:prose-base lg:prose-lg max-w-none text-justify aviso-content"
                    dangerouslySetInnerHTML={{ __html: item.avisoPrivacidad }}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Firma y Copyright */}
          <div className="text-center mt-4 sm:mt-6 md:mt-8 text-gray-600 text-xs sm:text-sm">
            <p>
              &copy; 2025 Industrial Business Clusters - Todos los derechos
              reservados
            </p>
          </div>
        </div>
      </div>

      {/* Footer con ancho completo usando el estilo personalizado */}
      <div style={fullWidthStyle} className="-mb-8">
        <FooterTransparent />
      </div>
    </>
  );
}

export default AvisoPage;
